import { useState } from "react";
import { versionCards } from "@/mocks/nanny";

export default function Versions() {
  const [active, setActive] = useState(versionCards[0].id);
  const current = versionCards.find((v) => v.id === active) ?? versionCards[0];

  return (
    <section id="versions" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-primary-600 font-label text-sm tracking-[0.2em] uppercase">Versions</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">版本一览</h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              同一段故事，三种讲法。先点选你感兴趣的版本，再决定从哪一部开始。
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-2 mb-8 md:mb-10">
            {versionCards.map((v) => (
              <button
                key={v.id}
                type="button"
                onClick={() => setActive(v.id)}
                className={`px-5 py-2 rounded-full text-sm md:text-base font-medium cursor-pointer transition-colors whitespace-nowrap ${
                  active === v.id
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-700 border border-background-300 hover:border-primary-300"
                }`}
              >
                {v.name}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-stretch">
            <div className="lg:col-span-5">
              <div className="grid grid-cols-3 gap-3 md:gap-4">
                {versionCards.map((v) => (
                  <button
                    key={v.id}
                    type="button"
                    onClick={() => setActive(v.id)}
                    aria-label={`选择 ${v.name}`}
                    className={`relative rounded-lg overflow-hidden border-2 cursor-pointer transition-all ${
                      active === v.id ? "border-primary-500" : "border-transparent opacity-70 hover:opacity-100"
                    }`}
                  >
                    <div className="w-full aspect-[3/4]">
                      <img
                        src={v.image}
                        alt={`《漂亮的保姆》${v.name} 海报视觉`}
                        title={`漂亮的保姆 ${v.name}`}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="h-full bg-background-50 border border-background-200 rounded-lg p-6 md:p-8 flex flex-col">
                <div className="flex items-center gap-3">
                  <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs md:text-sm font-medium">
                    {current.format}
                  </span>
                  <span className="text-foreground-500 text-sm">{current.episodes}</span>
                </div>
                <h3 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  {current.name}
                </h3>
                <p className="mt-2 text-primary-700 font-medium">{current.tagline}</p>

                <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { label: "单集时长", value: current.duration, icon: "ri-time-line" },
                    { label: "整体节奏", value: current.tone, icon: "ri-equalizer-line" },
                  ].map((item) => (
                    <div key={item.label} className="bg-background-100 rounded-lg p-4">
                      <div className="flex items-center gap-2 text-foreground-500 text-xs md:text-sm">
                        <i className={`${item.icon} text-base`}></i>
                        {item.label}
                      </div>
                      <p className="mt-1 text-foreground-900 font-medium text-sm md:text-base">{item.value}</p>
                    </div>
                  ))}
                </div>

                <ul className="mt-6 space-y-3">
                  {current.highlights.map((h) => (
                    <li key={h} className="flex items-start gap-2 text-foreground-700 text-sm md:text-base">
                      <i className="ri-checkbox-circle-line text-primary-600 text-lg mt-0.5"></i>
                      {h}
                    </li>
                  ))}
                </ul>

                <div className="mt-6 pt-5 border-t border-background-200 flex items-start gap-2 text-foreground-600 text-sm">
                  <i className="ri-user-heart-line text-secondary-500 text-lg mt-0.5"></i>
                  {current.audience}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}